import {createFileRoute} from '@tanstack/react-router';

import {NewAdvanceRequestPage} from '@/modules/advance-requests/pages/NewAdvanceRequestPage';

export const Route = createFileRoute('/_authenticated/advances/new')({
  component: NewAdvanceRequestPage,
});
